module.exports = __webpack_public_path__ + "img/engage-fig-4.ea771ca7.png";